import getIn from 'transmute/getIn';
const QUICK_LINKS = ['quickLinks'];
export const getQuickLinks = getIn(QUICK_LINKS);